import { formatPriceInput } from '../services/formatPrice';

/**
 * Resolve the effective per-ticket price in minor units.
 * For pwyw tickets the stored `price` is the minimum, used for validation
 * only — an empty input contributes 0 rather than pre-charging the minimum.
 */
export default function getResolvedTicketPrice(ticketType, payWhatYouWantAmount, currency) {
  const storedPrice = Number(ticketType.price) || 0;

  if (ticketType.pricing !== 'pwyw') return storedPrice;
  if (payWhatYouWantAmount == null || payWhatYouWantAmount === '') return 0;

  // formatPriceInput silently coerces unparseable strings (e.g. "abc") to 0
  // rather than NaN, so check for at least one digit before converting.
  if (!/\d/.test(String(payWhatYouWantAmount))) return 0;

  const converted = Number(formatPriceInput(payWhatYouWantAmount, currency));
  if (isNaN(converted)) return 0;

  return converted;
}
